import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { CtaButton } from "./ui";
import { checkout } from "../data/content";
export function StickyOfferBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const hero = document.getElementById("hero");
    const offer = document.getElementById("offer-details");
    const observers: IntersectionObserver[] = [];
    function onScroll() {
      const limit = hero ? hero.offsetTop + hero.offsetHeight * 0.7 : 400;
      setPastHero(window.scrollY > limit);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    if (offer) {
      const o = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
        threshold: 0.15
      });
      o.observe(offer);
      observers.push(o);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      observers.forEach(o => o.disconnect());
    };
  }, []);
  const show = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-219" data-mp="tlns7jp3oc61">
      {show && <motion.div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-4 py-3 shadow-[0_-8px_24px_rgba(22,78,85,0.1)] backdrop-blur" initial={reduceMotion ? {
      opacity: 0
    } : {
      y: "100%"
    }} animate={reduceMotion ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0
    } : {
      y: "100%"
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-220" data-mp="fp0wfk8vvs1p">
          <div className="mx-auto flex max-w-[1144px] items-center justify-between gap-3" data-id="element-221" data-mp="ymv0djv5ndd8">
            <div className="min-w-0" data-id="element-222" data-mp="13kmzaxu7vzqx">
              <p className="truncate font-display text-lg font-bold uppercase leading-tight text-petrol sm:text-xl" data-id="element-223" data-mp="1rbsedasc2o06">
                The Year-Round Kit
              </p>
              <p className="text-xs text-muted sm:text-sm" data-id="element-224" data-mp="1w3tsz3cz4qtd">
                ${checkout.price} {checkout.currency} · 10-day guarantee
              </p>
            </div>
            <CtaButton href="#offer-details" compact data-id="element-225" data-mp="210ftmodfavti">
              See the offer
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}